import { Component, Inject } from '@angular/core';
import { DialogComponentBase } from '@wephone-core-ui';
import { _tk, _ti } from '@wephone-translation';
import * as _ from 'lodash';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DidEntity } from '@wephone-core/model/entity/did';
import { DidRepository } from '@wephone-core/model/repository/did';
import { NumberLocationRepository } from '@wephone-core/model/repository/number_location';
import { NumberLocationEntity } from '@wephone-core/model/entity/number_location';
import { DialogService, regexSearch } from '@wephone-utils';
import { NumberLocationEditComponent } from '@wephone-common/number-location-edit/number-location-edit.component';

@Component({
  selector: 'did-update-number-location',
  templateUrl: './did-update-number-location.component.html',
  styleUrls: ['./did-update-number-location.component.scss']
})
export class DidUpdateNumberLocationComponent extends DialogComponentBase {
  dialogTitle = _tk('did.title.set_number_location');

  private readonly didRepo: DidRepository = DidRepository.getInstance();
  private readonly numberLocationRepo: NumberLocationRepository = NumberLocationRepository.getInstance();

  numberLocations: NumberLocationEntity[] = [];
  did: DidEntity;

  selectedItem: NumberLocationEntity;
  filterValue: string;

  constructor(
    dialogRef: MatDialogRef<DidUpdateNumberLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      did_id: number;
    },
    private readonly dialogService: DialogService
  ) {
    super(dialogRef);
  }

  async resolveData(): Promise<void> {
    await this.setData();
    this.updateDialogLayout();
  }

  private async setData(): Promise<void> {
    this.numberLocations = await this.numberLocationRepo.loadObjectList();
    this.setDid();
  }

  private setDid(): void {
    this.did = this.didRepo.getObjectById(this.data.did_id);
    if (this.did.number_location_id) {
      this.selectedItem = this.numberLocations.find(item => item.id === this.did.number_location_id);
    }
  }

  get numberLocationsFiltered(): NumberLocationEntity[] {
    if (!this.filterValue) {
      return this.numberLocations;
    }

    const s = this.filterValue.toLowerCase();
    return this.numberLocations.filter(item =>
      regexSearch(item.name.toLowerCase(), s) || regexSearch(item.address.toLowerCase(), s)
    );
  }

  isSelected(item: NumberLocationEntity): boolean {
    return this.selectedItem && this.selectedItem.id === item.id;
  }

  selectNumberLocation(item: NumberLocationEntity): void {
    this.selectedItem = item;
  }

  async applySelect(): Promise<any> {
    try {
      await this.didRepo.updateNumberLocation(this.did, this.selectedItem.id);
      this.successToast(_ti('public.message.update_success'));
      this.dismiss(this.selectedItem);
    } catch (error) {
      console.error('Update number location for DID failed', error);
      this.showErrorMessage(error, _ti('public.message.update_failed'));
    }
  }

  createNumberLocation(): void {
    this.dialogService.openDialog3(
      _tk('number_location.action.create'),
      NumberLocationEditComponent,
      {
        data: {
          item: new NumberLocationEntity(undefined, false)
        }
      },
      async (resp: any) => {
        await this.setData();

        const newItem = resp && resp.id && this.numberLocations.find(item => item.id === resp.id)
        if (newItem) {
          this.selectNumberLocation(newItem);
          this.applySelect();
        }
      }
    );
  }
}
